import { Command } from "./Command";
import { HistoryEventHandler } from "../history";

export class ResolutionChangeCommand extends Command {
    constructor(private oldW: number, private oldH: number, private newW: number, private newH: number, text?: string) {
        super();

        this.text = text || 'Batch Command';
    }

    apply(handler: HistoryEventHandler) {
        const canv = handler.getCanvas();
        canv.contentW = this.newW;
        canv.contentH = this.newH;
        canv.editor.updateCanvas();
    }

    unapply(handler: HistoryEventHandler) {
        const canv = handler.getCanvas();
        canv.contentW = this.oldW;
        canv.contentH = this.oldH;
        canv.editor.updateCanvas();
    }
}
